import React, { useState } from 'react'
import { Transition } from 'react-transition-group'
import styled, { DefaultTheme } from 'styled-components'

import { Image, ImageProps } from '../../Image'
import { Text } from '../../Text'
import { ThemeWrapper } from '../../theme'

type DropdownVariant = 'primary' | 'secondary'

const getBackgroundColorByType = (type: DropdownVariant, theme: DefaultTheme) => {
  const colors = {
    primary: 'primary',
    secondary: 'white'
  }

  // @ts-ignore
  return theme.colors[colors[type] || 'primary']
}

const getTextColorByType = (type: DropdownVariant) => {
  const colors = {
    primary: 'white',
    secondary: 'primary'
  }
  return colors[type] || 'white'
}

const Wrapper = styled.div<{ variant: DropdownVariant }>`
  width: 100%;
  display: flex;
  background: ${({ theme, variant }) => getBackgroundColorByType(variant, theme)};
  border-bottom: solid 1px ${({ theme }) => theme.colors.borderPrimary};
  flex-direction: column;
  overflow: hidden;
`

const DropdownHeader = styled.div`
  padding: 16px;
  display: flex;
  height: 60px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
`

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Icon = styled(({ open, ...rest }: ImageProps & { open: boolean }) => <Image {...rest} />)`
  transform: rotate(${({ open }) => (open ? '-90deg' : '0')});
  transition: all 0.2ms ease-in-out;
`

const ChildrenWrapper = styled.div`
  height: 0;
  transition: all 250ms ease-out;
  transform: translateX(-100%);
  opacity: 0;

  &.entered {
    opacity: 1;
    height: auto;
    transform: translateX(0);
  }
`

type Props = {
  children?: React.ReactNode | React.ReactNode[]
  title?: string
  content?: React.ReactNode
  variant?: DropdownVariant
  icon?: string
  hideIcon?: boolean
}

export const MobileMenuDropdown = ({ children, title, icon, content, hideIcon, variant = 'primary' }: Props) => {
  const [open, setOpen] = useState(false)

  return (
    <ThemeWrapper>
      <Wrapper variant={variant}>
        <DropdownHeader onClick={() => setOpen(!open)}>
          {title && (
            <Text color={getTextColorByType(variant)} bold block width="100%">
              {title}
            </Text>
          )}
          {content}
          {!hideIcon && (
            <Icon open={!icon && open} type={icon || (variant === 'primary' ? 'arrowRightWhite' : 'arrowRightBlue')} />
          )}
        </DropdownHeader>
        <Transition in={open} unmountOnExit mountOnEnter timeout={250}>
          {state => <ChildrenWrapper className={state}>{children}</ChildrenWrapper>}
        </Transition>
      </Wrapper>
    </ThemeWrapper>
  )
}
